

















































































































































import { Vue, Component } from 'vue-property-decorator';
import VoteButton from '../components/VoteButton.vue';
import { Popup, Dialog } from 'vant';
import {
  ifVote,
  detail,
  bgImgList,
  titleList,
  orderList,
  getRules,
} from '../api';
import { isWeiXin, WechatLogin } from '@/common/ts/common';
import UserCenter from '../components/UserCenter.vue';
import qs from 'qs';
Vue.use(Popup).use(Dialog);
let timer: any = null;
@Component({
  components: {
    VoteButton,
    UserCenter,
  },
})
export default class Share extends Vue {
  ruleShow = false;
  successVoteVar = false;
  scrollIndex = 0;
  detail: any = {};
  bgs: any = [];
  titles: any = [];
  voteStatus = false;
  rules: any = {};
  data = [];
  userCenterShow = false;
  // 动态显示热搜
  get scrollItem() {
    clearTimeout(timer);
    timer = setTimeout(() => {
      this.scrollIndex++;
    }, 5000);
    if (this.scrollIndex >= this.data.length) {
      this.scrollIndex = 0;
    }
    return this.data.length ? this.data[this.scrollIndex] : {};
  }
  get curBgs() {
    return {
      bg: this._matchBG(this.detail.background),
      title: this._matchTitle(this.detail.title),
    };
  }
  get voteParams() {
    const data: any = {
      id: this.detail.id,
    };
    if (isWeiXin()) {
      data.unionid = window.localStorage.getItem('unionid');
      data.wxnickname = window.localStorage.getItem('nickname');
      data.wxheadimg = window.localStorage.getItem('headimgurl');
    }
    return data;
  }
  get userInfo() {
    if (window.udid) {
      return {
        avatar: this.detail.headimg,
        name: this.detail.nickname,
      };
    } else {
      return {
        avatar: this.detail.wxheadimg,
        name: this.detail.wxnickname,
      };
    }
  }
  created() {
    if (isWeiXin() && !window.localStorage.getItem('unionid')) {
      WechatLogin();
    }

    const id = qs.parse(location.search)[`?id`];
    this.getData(id as string);
    this.getDetail(id as string);
    this.getOrderList();
    this.share();
  }
  afterSuccessVote(res: any) {
    this.successVoteVar = true;
    this.detail.votes = res;
    this.voteStatus = true;
    this.getDetail(this.detail.id);
  }
  async getData(id: string) {
    const bgs = await bgImgList();
    const titles = await titleList();
    const rulesRes = await getRules();
    const wxid = this._getWxId();
    const voteRes: any = await ifVote(wxid, id);
    this.bgs = bgs.data;
    this.titles = titles.data;

    this.rules = rulesRes.data;
    if (voteRes.code === 500) {
      this.voteStatus = true;
    }
  }
  async getDetail(id: string) {
    const data = await detail(id, this._getWxId());
    if (data.data.length === 0) {
      this.$router.push({
        path: 'home',
      });
    }
    this.detail = data.data;
  }
  async getOrderList() {
    const res = await orderList();
    this.data = res.data;
  }
  changeCenterShow(show: boolean) {
    (this.$refs.userCenter as UserCenter).userCenterShow = true;
  }
  jumpToApplyPage() {
    this.$router.push({
      path: 'home',
    });
  }
  _getWxId() {
    let id = '';
    const wxid = window.localStorage.getItem('unionid');
    if (isWeiXin() && wxid) {
      id = wxid as string;
    }
    return id;
  }
  _matchBG(id: string) {
    return this.bgs.filter((item: any) => item.id === id)[0];
  }
  _matchTitle(id: string) {
    return this.titles.filter((item: any) => item.id === id)[0];
  }
  share() {
    this.$appShareInfo({
      title: '光盘有奖 咖啡留香',
      url: location.href,
      subtitle:
        '我正在参与“光盘有奖 咖啡留香”珍惜食物活动，小伙伴们快来给我点赞吧',
      classId: -1,
      id: -1,
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '光盘有奖 咖啡留香',
        subtitle:
          '我正在参与“光盘有奖 咖啡留香”珍惜食物活动，小伙伴们快来给我点赞吧',
        link: location.href,
        image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      });
    }
  }
}
